import React from "react";
import Marquee from "react-fast-marquee";
import { useLang } from "@/i18n";

export default function EditorialMarquee() {
  const { t } = useLang();
  const text = t.marquee;
  return (
    <div className="py-8 bg-pine-900 border-y border-pine-800 overflow-hidden" data-testid="marquee">
      <Marquee speed={38} gradient={false} autoFill>
        <span className="font-serif italic text-sage text-3xl md:text-4xl px-8 select-none">
          {text}
        </span>
      </Marquee>
    </div>
  );
}
